import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { tillsale } from 'src/types/tillsale';
import { tillRoll } from 'src/types/tillRoll';
import { tillSalePayment } from 'src/types/tillsalepayment';
import { Payment } from 'src/PackageClasses';
import { cRefund } from 'src/types/refund';
import { venueuser } from 'src/types/venueuser';
import { venueuser_returndata } from 'src/types/venueuser_returndata';

@Component({
  selector: 'app-tillsalemanager',
  templateUrl: './tillsalemanager.component.html',
  styleUrls: ['./tillsalemanager.component.css']
})
export class TillsalemanagerComponent implements OnInit {


  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CurrencySymbol: string = localStorage.getItem("Currency") || "GBP";
  TillName: string = localStorage.getItem(`TillName_${localStorage.getItem("SmartVenueID")}`) || '';

  ListSales: tillsale[] = [];

  // Date filter
  selectedDate: Date = new Date();

  get venueDateParam(): string {
    const d = this.selectedDate;
    const day   = ('00' + d.getDate()).slice(-2);
    const month = ('00' + (d.getMonth() + 1)).slice(-2);
    const year  = d.getFullYear().toString();
    return day + month + year;
  }

  // List filters
  filterStatus: string = '';
  filterTable: string = '';
  filterID: string = '';
  filterProduct: string = '';

  readonly statusFilterOptions = [
    { label: 'All Statuses', value: '' },
    { label: 'Paid',         value: 'Paid' },
    { label: 'Outstanding',  value: 'Outstanding' },
    { label: 'Overpaid',     value: 'Overpaid' },
    { label: 'Tab',          value: 'Tab' },
    { label: 'Voided',       value: 'Voided' },
  ];

  get filteredSales(): tillsale[] {
    const status  = this.filterStatus.trim();
    const table   = this.filterTable.trim().toLowerCase();
    const id      = this.filterID.trim().toLowerCase();
    const product = this.filterProduct.trim().toLowerCase();
    if (!status && !table && !id && !product) return this.ListSales;
    return this.ListSales.filter(sale => {
      if (status  && this.getSaleStatusLabel(sale) !== status) return false;
      if (table   && !(sale.tablenumber ?? '').toLowerCase().includes(table)) return false;
      if (id      && !(sale.tillsaleidhr ?? '').toLowerCase().includes(id)) return false;
      if (product && !this.getProductsSummary(sale).toLowerCase().includes(product)) return false;
      return true;
    });
  }

  clearFilters(): void {
    this.filterStatus = '';
    this.filterTable  = '';
    this.filterID     = '';
    this.filterProduct = '';
  }

  productMap: Map<string, string> = new Map();
  unitPriceMap: Map<string, number> = new Map();
  productDataMap: Map<string, any> = new Map();
  userMap: Map<string, string> = new Map();

  // Options editor
  showOptionsEditor: boolean = false;
  editingItem: any = null;
  availableOptions: any[] = [];

  showDetailDialog: boolean = false;
  selectedSale: tillsale | null = null;

  orderTotal: number = 0;
  paymentsTotal: number = 0;

  // Add payment panel
  showAddPayment: boolean = false;
  newPaymentAmount: number = 0;
  newPaymentType: any = null;
  paymentTypes: any[] = [];

  // Refund against a specific payment
  showAddRefund: boolean = false;
  refundAmount: number = 0;
  refundReason: string = '';
  refundTargetPayment: any | null = null;

  // Overpayment refund
  showOverpaymentRefund: boolean = false;
  overpaymentRefundPayment: any = null;

  // Void confirmation
  showVoidConfirm: boolean = false;

  // Change table number
  showChangeTable: boolean = false;
  newTableNumber: string = '';

  // Till name prompt
  showTillNamePrompt: boolean = false;
  tillNameInput: string = '';


  httpResponse: any;

  // Admin override
  currentUser: any = null;
  showAdminOverride: boolean = false;
  adminOverrideUsers: venueuser[] = [];
  adminOverrideSelectedId: string = '';
  adminOverridePin: string = '';
  adminOverridePending: (() => void) | null = null;

  constructor(
    private http: HttpClient,
    private appComp: AppComponent,
    public router: Router,
    private messageService: MessageService,
    private busyService: BusyService,
    private globalService: GlobalService) {
  }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);
    if (!localStorage.getItem(`TillName_${this.VenueID}`) || localStorage.getItem(`TillName_${this.VenueID}`)!.trim() === '') {
      this.showTillNamePrompt = true;
    }
    const userid = localStorage.getItem('SmartUserID');
    if (userid) {
      this.http.get<any>(bmxurl + 'User/' + userid).subscribe({
        next: (response) => { if (response.succeeded) this.currentUser = response.data; },
        error: () => {}
      });
    }
    this.loadProducts();
    this.loadPaymentTypes();
    this.loadSales();
  }

  confirmTillName(): void {
    if (!this.tillNameInput || this.tillNameInput.trim() === '') {
      this.messageService.add({ severity: 'warn', summary: 'Till Name Required', detail: 'Please enter a name for this till.' });
      return;
    }
    localStorage.setItem(`TillName_${this.VenueID}`, this.tillNameInput.trim());
    this.TillName = this.tillNameInput.trim();
    this.showTillNamePrompt = false;
  }

  // ─── Data loading ──────────────────────────────────────────────────────────

  loadProducts(): void {
    this.http.get<any>(bmxurl + "TillProductList/" + this.VenueID + "/false").subscribe(response => {
      if (response.succeeded && response.data) {
        this.productMap = new Map(response.data.map((p: any) => [p.id, p.name]));
        this.unitPriceMap = new Map(response.data.map((p: any) => [p.id, p.price]));
        this.productDataMap = new Map(response.data.map((p: any) => [p.id, p]));
      }
    }, () => {});
  }

  loadSales(refreshSaleId?: string): void {
    this.busyService.busy();
    this.http.get<any>(bmxurl + "TillSaleTransactionList/" + this.VenueID + "/" + this.venueDateParam).subscribe(response => {
      if (response.succeeded) {
        this.ListSales = (response.data || []).filter((s: tillsale) => !s.disabled);
        this.loadUserNames();
        if (refreshSaleId) {
          const updated = this.ListSales.find(s => s.tillsaleid === refreshSaleId);
          if (updated) {
            this.selectedSale = JSON.parse(JSON.stringify(updated));
            this.recalculate();
          }
        }
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load transactions.' });
      }
      this.busyService.idle();
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load transactions.' });
      this.busyService.idle();
    });
  }

  loadUserNames(): void {
    const unknownIds = [...new Set(this.ListSales.map(s => s.userid).filter(id => id && !this.userMap.has(id)))];
    unknownIds.forEach(id => {
      this.http.get<any>(bmxurl + "User/" + id).subscribe(response => {
        if (response.succeeded && response.data?.name) {
          this.userMap.set(id, response.data.name);
        }
      }, () => {});
    });
  }

  getUserName(userid: string): string {
    return this.userMap.get(userid) || userid;
  }

  loadPaymentTypes(): void {
    this.http.get<any>(bmxurl + "paymenttypes").subscribe(response => {
      if (response.succeeded) {
        this.paymentTypes = (response.data || []).filter((pt: any) => !pt.system);
        if (this.paymentTypes.length > 0) {
          this.newPaymentType = this.paymentTypes[0];
        }
      }
    }, () => {});
  }

  // ─── Open / close transaction detail ──────────────────────────────────────

  openSale(sale: tillsale): void {
    this.selectedSale = JSON.parse(JSON.stringify(sale));
    (this.selectedSale.products ?? []).forEach((item: any) => {
      if (!item.selectedOptions?.length) {
        item.selectedOptions = item.SelectedOptions ?? item.options ?? item.Options ?? [];
      }
    });
    this.selectedSale.payments = this.selectedSale.payments || [];
    this.recalculate();
    this.closeAllPanels();
    this.showDetailDialog = true;
  }

  private closeAllPanels(): void {
    this.showAddPayment = false;
    this.showAddRefund = false;
    this.showOverpaymentRefund = false;
    this.showVoidConfirm = false;
    this.showChangeTable = false;
    this.newPaymentAmount = 0;
    this.newPaymentType = this.paymentTypes.length > 0 ? this.paymentTypes[0] : null;
    this.overpaymentRefundPayment = null;
    this.refundAmount = 0;
    this.refundReason = '';
    this.refundTargetPayment = null;
  }

  // ─── Product helpers ───────────────────────────────────────────────────────

  getItemName(item: any): string {
    const fromMap = this.productMap.get(item.id)
                 ?? this.productMap.get(item.productId)
                 ?? this.productMap.get(item.product?.id);
    if (fromMap) return fromMap;
    return item.product?.name ?? item.product?.Name
        ?? item.name ?? item.Name
        ?? item.productName ?? '(unknown)';
  }

  getItemUnitPrice(item: any): number {
    const fromMap = this.unitPriceMap.get(item.id)
                 ?? this.unitPriceMap.get(item.productId)
                 ?? this.unitPriceMap.get(item.product?.id);
    if (fromMap != null) return fromMap;
    if (item.product?.price != null) return item.product.price;
    // Derive unit price from line total ÷ qty rather than returning the line total directly
    const qty = item.qty ?? 1;
    return qty > 0 ? (item.price ?? 0) / qty : (item.price ?? 0);
  }

  getItemOptions(item: any): any[] {
    return item.selectedOptions ?? item.SelectedOptions ?? item.options ?? item.Options ?? [];
  }

  // ─── Quantity controls ─────────────────────────────────────────────────────

  increaseQty(item: tillRoll): void {
    item.qty = (item.qty ?? 1) + 1;
    this.recalcLinePrice(item);
    this.recalculate();
  }

  decreaseQty(item: tillRoll): void {
    const current = item.qty ?? 1;
    if (current <= 1) {
      item.qty = 0;
      item.disabled = true;
    } else {
      item.qty = current - 1;
    }
    this.recalcLinePrice(item);
    this.recalculate();
  }

  private recalcLinePrice(item: any): void {
    const unitPrice = this.getItemUnitPrice(item);
    const opts = this.getItemOptions(item);
    const optionsPrice = opts.reduce((sum: number, o: any) => sum + (o.price ?? 0), 0);
    item.price = (unitPrice + optionsPrice) * item.qty;
  }

  recalculate(): void {
    if (!this.selectedSale) return;
    this.orderTotal = this.selectedSale.products
      .filter((p: any) => !p.disabled)
      .reduce((sum: number, p: any) => sum + (p.price ?? 0), 0);
    this.paymentsTotal = (this.selectedSale.payments || [])
      .filter((p: any) => !p.disabled)
      .reduce((sum: number, p: any) => sum + (p.amount ?? 0), 0);
  }

  get outstanding(): number {
    return this.orderTotal - this.paymentsTotal;
  }

  get isOverpaid(): boolean {
    return this.outstanding < -0.001;
  }

  get overpaidAmount(): number {
    return Math.abs(this.outstanding);
  }

  // ─── Save item changes ─────────────────────────────────────────────────────

  saveChanges(): void {
    if (!this.selectedSale) return;
    this.selectedSale.total = this.orderTotal;
    this.busyService.busy();
    this.http.post<any>(bmxurl + "tillsale", this.selectedSale).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Transaction updated.' });
        if (response.data) {
          this.selectedSale = response.data;
          this.selectedSale.payments = this.selectedSale.payments || [];
          this.recalculate();
        }
        this.loadSales();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not save changes.' });
      }
      this.busyService.idle();
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save changes.' });
      this.busyService.idle();
    });
  }

  // ─── Void transaction ──────────────────────────────────────────────────────

  requestVoid(): void {
    this.closeAllPanels();
    this.showVoidConfirm = true;
  }

  confirmVoid(): void {
    if (!this.selectedSale) return;
    this.selectedSale.voided = true;
    this.selectedSale.total = this.orderTotal;
    this.showVoidConfirm = false;
    this.busyService.busy();
    this.http.post<any>(bmxurl + "tillsale", this.selectedSale).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'info', summary: 'Voided', detail: 'Transaction has been voided.' });
        if (response.data) {
          this.selectedSale = response.data;
          this.selectedSale.payments = this.selectedSale.payments || [];
          this.recalculate();
        }
        this.loadSales();
      } else {
        if (this.selectedSale) this.selectedSale.voided = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not void transaction.' });
      }
      this.busyService.idle();
    }, () => {
      if (this.selectedSale) this.selectedSale.voided = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not void transaction.' });
      this.busyService.idle();
    });
  }

  cancelVoid(): void {
    this.showVoidConfirm = false;
  }

  // ─── Change table number ───────────────────────────────────────────────────

  openChangeTable(): void {
    this.closeAllPanels();
    this.newTableNumber = this.selectedSale?.tablenumber ?? '';
    this.showChangeTable = true;
  }

  cancelChangeTable(): void {
    this.showChangeTable = false;
  }

  confirmChangeTable(): void {
    if (!this.selectedSale) return;

    let tableNumber = (this.newTableNumber ?? '').trim();

    if (tableNumber == '') {
      this.messageService.add({ severity: 'warn', summary: 'Table Number Required', detail: 'Please enter a table number.' });
      return;
    }

    let saleId = this.selectedSale.tillsaleid;

    this.selectedSale.tablenumber = tableNumber;
    this.selectedSale.total = this.orderTotal;
    this.showChangeTable = false;
    this.busyService.busy();

    this.http.post<any>(bmxurl + "tillsale", this.selectedSale).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Table Changed', detail: 'Table number updated to ' + tableNumber + '.' });
        //Reload the list so the grid shows the new number, and pass the sale id so the
        //open detail is refreshed from what the server actually stored.
        this.loadSales(saleId);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not change the table number.' });
        this.loadSales(saleId);
      }
      this.busyService.idle();
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not change the table number.' });
      this.loadSales(saleId);
      this.busyService.idle();
    });
  }

  // ─── Add payment ───────────────────────────────────────────────────────────

  openAddPayment(): void {
    this.closeAllPanels();
    this.newPaymentAmount = this.outstanding > 0 ? this.outstanding : 0;
    this.showAddPayment = true;
  }

  confirmAddPayment(): void {
    if (!this.selectedSale || !this.newPaymentType || this.newPaymentAmount <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Invalid', detail: 'Please enter a valid amount and select a payment method.' });
      return;
    }

    const payment: Payment = {
      id: null,
      PaymentId: '',
      BookingId: this.selectedSale.tillsaleid,
      bookingIdHR: this.selectedSale.tillsaleidhr || '',
      method: this.newPaymentType.name,
      paymenttypeid: this.newPaymentType.id,
      amount: this.newPaymentAmount,
      paymentDate: new Date(),
      disabled: false,
      venueid: this.VenueID,
      refunds: [],
      balance: this.newPaymentAmount,
      paymenttype: 'till',
      currency: this.CurrencySymbol,
      tillname: this.TillName || null
    };

    this.selectedSale.payments.push(payment);
    this.selectedSale.total = this.orderTotal;
    this.recalculate();
    this.showAddPayment = false;
    this.newPaymentAmount = 0;

    this.busyService.busy();
    this.http.post<any>(bmxurl + "tillsale", this.selectedSale).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Payment Added', detail: 'Payment recorded successfully.' });
        if (response.data) {
          this.selectedSale = response.data;
          this.selectedSale.payments = this.selectedSale.payments || [];
          this.recalculate();
        }
        this.loadSales();
      } else {
        this.selectedSale?.payments.pop();
        this.recalculate();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not add payment.' });
      }
      this.busyService.idle();
    }, () => {
      this.selectedSale?.payments.pop();
      this.recalculate();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not add payment.' });
      this.busyService.idle();
    });
  }

  cancelPaymentPanel(): void {
    this.showAddPayment = false;
    this.newPaymentAmount = 0;
  }

  // ─── Refund against a specific payment ────────────────────────────────────

  openRefundFor(payment: tillSalePayment): void {
    this.requireAdminApproval(() => {
      this.closeAllPanels();
      this.refundTargetPayment = payment;
      this.refundAmount = payment.amount;
      this.showAddRefund = true;
    });
  }

  confirmRefund(): void {
    if (!this.selectedSale || !this.refundTargetPayment || this.refundAmount <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Invalid', detail: 'Please enter a valid refund amount.' });
      return;
    }

    const saleId = this.selectedSale.tillsaleid;

    const newRefund: cRefund = {
      venueid: this.VenueID,
      paymentid: this.refundTargetPayment.paymentId,
      reason: this.refundReason,
      amount: this.refundAmount,
      notes: '',
      disabled: false
    };

    this.showAddRefund = false;
    this.refundTargetPayment = null;
    this.refundAmount = 0;
    this.refundReason = '';

    this.busyService.busy();
    this.http.post<any>(bmxurl + "refund", newRefund).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Refund Issued', detail: 'Refund has been recorded.' });
        this.loadSales(saleId ?? undefined);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not process refund.' });
      }
      this.busyService.idle();
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not process refund.' });
      this.busyService.idle();
    });
  }

  cancelRefundPanel(): void {
    this.showAddRefund = false;
    this.refundTargetPayment = null;
    this.refundAmount = 0;
    this.refundReason = '';
  }

  // ─── Overpayment refund ────────────────────────────────────────────────────

  openOverpaymentRefund(): void {
    this.requireAdminApproval(() => {
      this.closeAllPanels();
      const payments = (this.selectedSale?.payments || []).filter((p: any) => !p.disabled && p.amount > 0);
      this.overpaymentRefundPayment = payments.length > 0 ? payments[payments.length - 1] : null;
      this.showOverpaymentRefund = true;
    });
  }

  confirmOverpaymentRefund(): void {
    if (!this.selectedSale || !this.overpaymentRefundPayment || this.overpaidAmount <= 0) return;

    const saleId = this.selectedSale.tillsaleid;

    const newRefund: cRefund = {
      venueid: this.VenueID,
      paymentid: this.overpaymentRefundPayment.paymentid,
      notes: 'Overpayment Refund',
      amount: this.overpaidAmount,
      reason: '',
      disabled: false
    };

    this.showOverpaymentRefund = false;

    this.busyService.busy();
    this.http.post<any>(bmxurl + "refund", newRefund).subscribe(response => {
      if (response.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Refund Issued', detail: 'Overpayment refunded.' });
        this.loadSales(saleId ?? undefined);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: response.messages?.[0] || 'Could not process refund.' });
      }
      this.busyService.idle();
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not process refund.' });
      this.busyService.idle();
    });
  }

  cancelOverpaymentRefund(): void {
    this.showOverpaymentRefund = false;
  }

  // ─── List helpers ──────────────────────────────────────────────────────────

  getSalePaid(sale: tillsale): number {
    return (sale.payments || [])
      .filter((p: any) => !p.disabled)
      .reduce((sum: number, p: any) => sum + (p.amount ?? 0), 0);
  }

  getSaleOutstanding(sale: tillsale): number {
    return (sale.total ?? 0) - this.getSalePaid(sale);
  }

  getSaleStatusLabel(sale: tillsale): string {
    if (sale.voided) return 'Voided';
    const bal = this.getSaleOutstanding(sale);
    if (bal > 0.001) return sale.istab ? 'Tab' : 'Outstanding';
    if (bal < -0.001) return 'Overpaid';
    return 'Paid';
  }

  getSaleStatusSeverity(sale: tillsale): string {
    if (sale.voided) return 'danger';
    const bal = this.getSaleOutstanding(sale);
    if (bal > 0.001) return 'warning';
    if (bal < -0.001) return 'info';
    return 'success';
  }

  getProductsSummary(sale: tillsale): string {
    if (!sale.products || sale.products.length === 0) return '—';
    return sale.products
      .filter((p: any) => !p.disabled)
      .map((p: any) => this.getItemName(p) + (p.qty > 1 ? ' ×' + p.qty : ''))
      .join(', ');
  }

  // ─── Edit in Till ──────────────────────────────────────────────────────────

  editInTill(): void {
    if (!this.selectedSale) return;
    sessionStorage.setItem('editTillSale', JSON.stringify(this.selectedSale));
    this.showDetailDialog = false;
    this.router.navigateByUrl('/till');
  }

  // ─── Options editor ────────────────────────────────────────────────────────

  editItemOptions(item: any): void {
    if (!item.selectedOptions?.length) {
      item.selectedOptions = item.SelectedOptions ?? item.options ?? item.Options ?? [];
    }
    this.editingItem = item;
    const productId = item.id ?? item.productId ?? item.product?.id;
    const product = this.productDataMap.get(productId);
    this.availableOptions = (product?.options ?? []).filter((o: any) => !o.disabled);
    this.showOptionsEditor = true;
  }

  isOptionSelected(opt: any): boolean {
    return !!(this.editingItem?.selectedOptions ?? []).find((o: any) => o.id === opt.id);
  }

  toggleOption(opt: any): void {
    if (!this.editingItem) return;
    if (!this.editingItem.selectedOptions) this.editingItem.selectedOptions = [];
    if (this.isOptionSelected(opt)) {
      this.editingItem.selectedOptions = this.editingItem.selectedOptions.filter((o: any) => o.id !== opt.id);
    } else {
      this.editingItem.selectedOptions = [...this.editingItem.selectedOptions, { ...opt }];
    }
    this.recalcLinePrice(this.editingItem);
    this.recalculate();
  }

  closeOptionsEditor(): void {
    this.showOptionsEditor = false;
    this.editingItem = null;
    this.availableOptions = [];
  }

  // ─── Admin override ────────────────────────────────────────────────────────

  requireAdminApproval(action: () => void): void {
    if (this.currentUser?.accesscontrol?.name === 'Venue Administrator') {
      action();
      return;
    }
    this.adminOverridePending = action;
    this.adminOverrideSelectedId = '';
    this.adminOverridePin = '';
    this.http.get<venueuser_returndata>(bmxurl + 'UserList/' + this.VenueID + '/false').subscribe({
      next: (response) => {
        this.adminOverrideUsers = (response.data ?? []).filter(u => u.accesscontrol?.name === 'Venue Administrator');
        if (this.adminOverrideUsers.length === 0) {
          this.messageService.add({ severity: 'error', summary: 'No Administrators', detail: 'No Venue Administrator accounts found.' });
          this.adminOverridePending = null;
          return;
        }
        this.showAdminOverride = true;
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load administrator list.' })
    });
  }

  submitAdminOverride(): void {
    if (!this.adminOverrideSelectedId || !this.adminOverridePin) {
      this.messageService.add({ severity: 'warn', summary: 'Required', detail: 'Please select an administrator and enter their PIN.' });
      return;
    }
    const payload = { venueid: this.VenueID, userid: this.adminOverrideSelectedId, pin: this.adminOverridePin };
    this.http.post<any>(bmxurl + 'pinauth', payload).subscribe({
      next: (response) => {
        if (response.succeeded) {
          const pending = this.adminOverridePending;
          this.cancelAdminOverride();
          if (pending) pending();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Authorisation Failed', detail: response.messages?.[0] ?? 'Incorrect PIN.' });
        }
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not verify credentials.' })
    });
  }

  cancelAdminOverride(): void {
    this.showAdminOverride = false;
    this.adminOverrideSelectedId = '';
    this.adminOverridePin = '';
    this.adminOverridePending = null;
  }
}
